import ButtonForm from './button-form';
import Chart from './chart';
import ColorInput from './color-input';
import DatetimeInput from './datetime-input';
import DesktopPagination from './desktop-pagination';
import FileInput from './file-input';
import Form from './form';
import Hcaptcha from './hcaptcha';
import Hugerte from './hugerte';
import ListPage from './list-page';
import MobilePagination from './mobile-pagination';
import PasswordInput from './password-input';
import SelectWithCustomInput from './select-with-custom-input';
import Select from './select';
import Select2 from './select2';
import Shiki from './shiki';
import Textarea from './textarea';
import TomSelect from './tom-select';
import Turnstile from './turnstile';

export default Object.freeze({
    ButtonForm,
    Chart,
    ColorInput,
    DatetimeInput,
    DesktopPagination,
    FileInput,
    Form,
    Hcaptcha,
    Hugerte,
    ListPage,
    MobilePagination,
    PasswordInput,
    SelectWithCustomInput,
    Select,
    Select2,
    Shiki,
    Textarea,
    TomSelect,
    Turnstile,
});
